import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
    vendor: null,
    loggedIn: false,
    loginRedirect: null,
    onboardStatus: false,
    hasLessonAccess: false
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 30, secure: true}),
        removeItem: key => Cookies.remove(key)
      },
      reducer: (persistedState) => {
        const stateFilter = Object.assign({}, persistedState)
        const reduceKeys = []
  
        reduceKeys.forEach((item) => {
          delete stateFilter[item]
        })
  
        return stateFilter
      }
    })
  ],
  mutations: {
    setToken(state, token) {
      state.token = token;
      state.loggedIn = !!token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setVendor(state, vendor) {
      state.vendor = vendor;
    },
    setLessonAccess(state, hasLessonAccess) {
      state.hasLessonAccess = hasLessonAccess;
    },
    setLoginRedirect(state, o) {
      state.loginRedirect = o;
    },
    setOnboardStatus(state, val) {
      state.onboardStatus = val;
    },
    logout(state) {
      state.user = null;
      state.token = null;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit("setToken", token);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    setVendor({ commit }, vendor) {
      commit("setVendor", vendor);
    },
    setLessonAccess({ commit }, hasLessonAccess) {
      commit("setLessonAccess", hasLessonAccess);
    },
    setLoginRedirect({ commit }, o) {
      commit("setLoginRedirect", o);
    },
    setOnboardStatus({ commit}, trueOrFalse) {
      commit("setOnboardStatus", trueOrFalse)
    },
    logout({ commit }) {
      commit("setToken", null)
      commit("setUser", null)
    }
  },
  getters: {
    loggedIn: state => {
      return state.loggedIn;
    },
    user: state => {
      return state.user;
    },
    vendor: state => {
      return state.vendor;
    },
    hasLessonAccess: state => {
      return state.hasLessonAccess;
    },
    token: state => {
      return state.token;
    },
    loginRedirect: state => {
      return state.loginRedirect
    },
    onboardStatus: state => {
      return state.onboardStatus
    }
  }
});